import React from 'react';
import "./footer.css";
import { FiGithub, FiLinkedin, FiPhone } from 'react-icons/fi';
import { BsWhatsapp } from 'react-icons/bs';

const Footer = () => {
  const phoneNumber = "+989375188740"; // شماره تلفن شما
  
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">A+A</h1>
            
            <ul className="footer__list">
                <li><a href="#about" className="footer__link">About</a></li>
                <li><a href="#portfolio" className="footer__link">Projects</a></li>
                {/* اضافه کردن لینک Contact */}
                <li><a href="#contact" className="footer__link">Contact</a></li>
            </ul>
            
            <div className="footer__social">
                {/* GitHub */}
                <a href="https://github.com/ashkanazimei" 
                   className="home__social-icon" 
                   target="_blank" 
                   rel="noreferrer noopener"
                   aria-label="GitHub Profile">
                    <FiGithub />
                </a>
                
                {/* LinkedIn */}
                <a href="https://www.linkedin.com/in/ashkan-azimi-010712365/" 
                   className="home__social-icon" 
                   target="_blank" 
                   rel="noreferrer noopener"
                   aria-label="LinkedIn Profile">
                    <FiLinkedin />
                </a>
                
                {/* WhatsApp */}
                <a href={`https://wa.me/${phoneNumber.replace('+', '')}`}
                   className="home__social-icon whatsapp-icon" 
                   target="_blank" 
                   rel="noreferrer noopener"
                   aria-label="Chat on WhatsApp"
                   title="Chat on WhatsApp">
                    <BsWhatsapp />
                </a>
                
                {/* Phone Call */}
                <a href={`tel:${phoneNumber}`} 
                   className="home__social-icon phone-icon" 
                   aria-label="Call me"
                   title="Call me">
                    <FiPhone />
                </a>
            </div>
            
            <span className="footer__copy">
                <div className="contact-info" style={{ marginTop: '10px', fontSize: '14px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {/* شماره تلفن */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                        <FiPhone style={{ verticalAlign: 'middle' }} />
                        <a href={`tel:${phoneNumber}`} 
                           style={{ color: 'inherit', textDecoration: 'none' }}
                           aria-label="Phone number">
                            {phoneNumber.replace('+98', '0')}
                        </a>
                    </div>
                    
                    {/* واتساپ */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                        <BsWhatsapp style={{ verticalAlign: 'middle', color: '#25D366' }} />
                        <a href={`https://wa.me/${phoneNumber.replace('+', '')}`}
                           target="_blank"
                           rel="noreferrer noopener"
                           style={{ color: 'inherit', textDecoration: 'none' }}
                           aria-label="WhatsApp contact">
                            WhatsApp
                        </a>
                    </div>
                </div>
                
                <div style={{ marginTop: '15px', fontSize: '12px', opacity: 0.7 }}>
                    © {new Date().getFullYear()} Design by Ashkan Azimi.
                </div>
            </span>
        </div>
    </footer>
  );
}

export default Footer;